import * as React from 'react';

import { Search } from '@organisms/ResidenceSearch/Search';
import {useModal} from "features/modal/hooks/useModal";

import './style.scss';

import { Button, ButtonColor, ButtonSize, ButtonType } from '@atoms/LinksAndButtons/Button';
import { FormattedMessage } from 'react-intl';
import { A } from '@atoms/LinksAndButtons/A';
import { P } from '@atoms/Text/P';
import { useSearchStore, selectSearchTags } from 'features/search/store/useSearchStore';

export const ResidenceSearchModal: React.FunctionComponent = () => {
    const { close } = useModal();
    const selectedTags = useSearchStore(selectSearchTags);
    const clearSearchTags = useSearchStore(state => state.clearSearchTags);

    const searchClick = (e: React.FormEvent) => {
        e.preventDefault();
        close();
    };

    return (
        <div className="residence-search__modal">
            <div className='modal-body'>
                <Search hideTitle inModal /> 
                <div className="residence-search__modal__mobile-buttons">
                    {selectedTags.length > 0 &&
                        <A href="#" title='' onClick={clearSearchTags}>
                            <FormattedMessage id="jm.components.SearchField.Clear" />
                        </A>
                    }
                    <Button 
                        buttonColor={ButtonColor.DEFAULT} 
                        buttonType={ButtonType.DEFAULT} 
                        buttonSize={ButtonSize.FULL} 
                        onClick={searchClick}
                    >
                        <FormattedMessage id="jm.components.SearchField.Search" />
                    </Button>
                </div>
            </div>
        </div>
    )
};
